import React from 'react';
import { View, Text, Button, TouchableOpacity, TextInput, Alert, Platform } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import i18n from './../../util/i18n';

i18n.locale = 'fr';
class Login extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      group_id: '',
      password: ''
    };
  }

  // store group id in local storage
  storeGroupId = async (group_id) => {
    try {
      await AsyncStorage.setItem('group_id', group_id)
    } catch (e) {
      console.log(e);
    }
  }


  getGroupId = async () => {
    try {
        const group_id = await AsyncStorage.getItem('group_id');
        if (group_id !== null) {
            this.setState({ group_id: group_id });
            this.props.navigation.navigate('Home', { group_id: group_id });
        }
    } catch(e) {
        console.log(e);
    }
  }

  componentDidMount() {
    this.getGroupId();
  }

  render() {
    return (
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
        <TextInput
          placeholder={i18n.t('enter_group_id')}
          style={{ height: 40, borderColor: 'gray', borderWidth: 1, borderRadius: 5, padding: 5, textAlign: 'center', margin: 10, width: '80%' }}
          onChangeText={(text) => {
            text = text.trim();
            this.setState({ group_id: text })
          }}
        />
        {/* <TextInput
          placeholder={i18n.t('password')}
          style={{ height: 40, borderColor: 'gray', borderWidth: 1, borderRadius: 5, padding: 5, textAlign: 'center', margin: 10, width: '80%' }}
          onChangeText={(text) => {
            this.setState({ password: text })
          }}
          secureTextEntry={true}
        /> */}
        <TouchableOpacity
          style={{ backgroundColor: this.state.group_id ? 'blue' : 'gray', padding: 10, borderRadius: 5, marginTop: 10, width: '80%', alignItems: 'center' }}
          onPress={() => {

            // check if password is correct
            // if (this.state.password !== '17084') {
            //   alert(i18n.t('invalid_password'));
            //   return;
            // }

            // store group id in local storage
            this.storeGroupId(this.state.group_id);

            // redirect to home
            this.props.navigation.navigate('Home', { group_id: this.state.group_id })
          }}
          disabled={!this.state.group_id}
        >
          <Text style={{ color: 'white' }}>{i18n.t('login')}</Text>
        </TouchableOpacity>
      </View>
    );
  }
}

export default Login;